exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button[data-v-e43d8f2a],\n.container[data-v-e43d8f2a],\n.error-msg[data-v-e43d8f2a] {\n    margin: 16px;\n}\n.droparea[data-v-e43d8f2a] {\n    width: 100%;\n    height: 100%;\n}\n#upload[data-v-e43d8f2a] {\n    text-align: center;\n    height: 100%;\n}\n.uploading[data-v-e43d8f2a] {\n    width: 100%;\n    text-align: center;\n.circle.notch[data-v-e43d8f2a] {\n        margin-bottom: 12px;\n        height: 20px;\n        width: 22px;\n}\n.progress-indicator[data-v-e43d8f2a] {\n        margin-bottom: 36px;\n}\n}\n.hidden[data-v-e43d8f2a] {\n    visibility: hidden;\n}\n", ""]);

// exports
